<template lang="pug">
  #select-plan
    #tmp-container.mt-5.mr-3
      b-card-group(deck)
        b-card(v-for="plan in plans", :key="plan.title", :header="plan.title" class="text-center card font-weight-bold" footer-tag="footer")
          b-card-text
            small 1ユーザー
            h5.font-weight-bold ￥{{plan.price.toLocaleString()}} / 月

            small ご利用いただけるサービス
            .mb-2
            div.mb-3.mr-3(v-if="plan.services.includes('neo')")
              img.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
            div.mb-3.mr-3(v-if="plan.services.includes('appsuite')")
              img.logo_appsuite(src="@/assets/images/logo_appsuite.png")
            div.mb-3.mr-3(v-if="plan.services.includes('chatluck')")
              img.logo_chatluck(src="@/assets/images/logo_chatluck.png")
          template#footer
            .height-service-1(v-if="plan.services.length === 1")
            .height-service-2(v-if="plan.services.length === 2")
            b-button.float-right.mr-5.my-3(pill, variant="outline-primary", size="ml", @click="applyPlan(plan.plan)")
              .float-left.search_message.mr-1.font-weight-bold 申し込む
              b-icon.float-right.next-icon(icon="arrow-right-circle")
</template>

<script>
export default {
  name: "SelectPlan",
  props: {
    value: { type: Object, required: false }
  },
  data() {
    return {
      plans: [
        { title: 'ライト', price: 660, services:['neo'], plan:'light' },
        { title: 'スタンダード', price: 880, services:['neo', 'appsuite'], plan:'standard' },
        { title: 'プレミアム', price: 1100, services:['neo', 'appsuite', 'chatluck'], plan:'premium' },
        { title: 'チャットプラス', price: 836, services:['neo', 'chatluck'], plan:'chatplus' },
        { title: 'ChatLuck', price: 330, services:['chatluck'], plan:'chatluck' }
      ]
    }
  },
  methods: {
    applyPlan(plan) {
      // プランをセットする
      this.value.plan_name = plan

      // サービス内容入力画面に遷移
      this.$router.push({
        name: 'InputServiceContents',
        query: {
          token: this.value.token
        }
      })
    }
  }
}
</script>

<style scoped>
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.logo_appsuite {
  width:100px;
  height: auto;
}
.height-service-1 {
  height: 80px;
}
.height-service-2 {
  height: 40px;
}
</style>